import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    name: {
      label: {
        id: 'properties.name',
        defaultMessage: 'Name',
        description: 'label of the name field',
      },
    },
    defaultSettings: {
      label: {
        id: 'properties.defaultSettings',
        defaultMessage: 'Default settings',
        description: 'subheader for the default settings',
      },
    },
    limit: {
      label: {
        id: 'properties.limit',
        defaultMessage: 'Limit',
        description: 'label of the limit field',
      },
    },
    expiresAfter: {
      label: {
        id: 'properties.expiresAfter',
        defaultMessage: 'Expires after amount of days',
        description: 'label of the expires after field',
      },
    },
    isUnlimited: {
      label: {
        id: 'properties.isUnlimited',
        defaultMessage: 'Unlimited',
        description: 'label of the expires after field',
      },
    },
  },
};

export default defineMessages(translations);
